export default {
  events: {
    store_chk_unlogged_access_success: 'Carregamento do checkout deslogado com sucesso',
    store_chk_unlogged_access_failed: 'Carregamento do checkout deslogado com falha',
    store_chk_login: 'Tentativa de login (Clique para logar)',
    store_chk_login_success: 'Tentativa de login com sucesso',
    store_chk_login_failed: 'Tentativa de login com falha',
    store_chk_register: 'Tentativa de cadastro (Clique pra abrir o form)',
    store_chk_register_success: 'Tentativa de cadastro com sucesso',
    store_chk_register_failed: 'Tentativa de cadastro com falha',
    store_chk_logged_access_success: 'Carregamento do checkout logado com sucesso',
    store_chk_logged_access_failed: 'Carregamento do checkout logado com falha',
    store_chk_eligibility_false: 'Quando não abre recomendação e abrimos o botão de "Minhas assinaturas"',
    store_chk_show_offer_recommendation: 'Exibição de recomendação de oferta em falha de elegibilidade ou de disponibilidade',
    store_chk_clicked_recommendation_offer: 'Clicou para ver oferta recomendada',
    store_chk_show_recommendation_la: 'Exibição de recomendação de acesso ao conteudo na área logada',
    store_chk_clicked_recommendation_la: 'Clicou para ver conteudo na área logada',
    store_chk_renewal_redirect: 'Redirecionamento para a página de renovação',
    store_chk_renewal_redirect_failed: 'Falha no redirecionamento para a página de renovação',
    store_chk_order: 'Tentativa de compra (Clique em Comprar)',
    store_chk_order_success: 'Tentativa de compra com sucesso',
    store_chk_order_payment_failed: 'Tentativa de compra com falha - Erro de Pagamento',
    store_chk_order_system_failed: 'Tentativa de compra com falha - Erro Sistêmico',
    store_chk_logout: 'Deslogou',
    store_chk_password_recovery: 'Tentativa de recuperação de senha',
    store_chk_password_recovery_success: 'Tentativa de recuperação de senha com sucesso (e-mail enviado)',
    store_chk_password_recovery_failed: 'Tentativa de recuperação de senha com falha (não encontrou usuário)',
    store_upsell_offer: 'Mostrar oferta de upsell',
    store_upsell_offer_denied: 'Clique de botão de negar upsell',
    store_upsell_order: 'Clica no botão de comprar upsell',
    store_upsell_order_success: 'Tentativa de compra upsell com sucesso',
    store_upsell_order_payment_failed: 'Tentativa de compra upsell com falha  - Erro de Pagamento',
    store_upsell_order_system_failed: 'Tentativa de compra upsell com falha - Erro Sistêmico',
    store_chk_cupom_show: 'Habilitar input do cupom',
    store_chk_cupom_submit: 'Botão de submit',
    store_chk_cupom_success: 'Uso de Cupom com Sucesso',
    store_chk_cupom_failed: 'Uso de Cupom com Falha',
  },
};
